export default "__VITE_ASSET__CeVPjrNl__"